import { render, staticRenderFns } from "./officialUrl.vue?vue&type=template&id=8b60234c&scoped=true"
import script from "./officialUrl.vue?vue&type=script&lang=js"
export * from "./officialUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b60234c",
  null
  
)

export default component.exports